/**
 * ToolsStrip — Redesign v2
 *
 * Compact 4-column tools row. Visually the CALMEST zone on the home —
 * flat, low-chrome, small gold-accent icons. Secondary utilities live
 * here so the hero CTA retains its rarity.
 *
 * Props:
 *   items : [{ id, icon, label, onClick }]
 */
import React from 'react';

const ToolItem = ({ icon: Icon, label, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="cv-font-ui"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 4px',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      width: '100%',
    }}
  >
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.07)',
        color: 'var(--cv-gold-primary)',
      }}
    >
      {Icon ? <Icon size={16} strokeWidth={1.5} /> : null}
    </span>
    <span
      style={{
        fontSize: '11px',
        color: 'var(--cv-text-body)',
        lineHeight: 1.2,
        textAlign: 'center',
      }}
    >
      {label}
    </span>
  </button>
);

const ToolsStrip = ({ items = [] }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${items.length || 4}, 1fr)`,
      gap: '6px',
      padding: '4px 0',
    }}
    data-testid="tools-strip"
  >
    {items.map((it) => (
      <ToolItem
        key={it.id}
        icon={it.icon}
        label={it.label}
        onClick={it.onClick}
        testId={`tool-${it.id}`}
      />
    ))}
  </div>
);

export default ToolsStrip;
